import { post, handleError } from '@/lib/http-adapter';

export interface PurchaseEligibilityRequest {
  user_id?: string;
  email?: string;
  phone?: string;
  country_code?: string;
  class_pack_id?: string;
  subscription_id?: string;
  switch_from_subscription_code_id?: string;
}

export interface EligibilityResult {
  eligible: boolean;
  reason:
    | 'ALREADY_PURCHASED'
    | 'ACTIVE_SUBSCRIPTION_EXISTS'
    | 'NEW_CUSTOMERS_ONLY'
    | 'NOT_FOUND'
    | null;
}

export type EligibilityReason = NonNullable<EligibilityResult['reason']>;

export interface PurchaseEligibilityResponse {
  class_pack: (EligibilityResult & { class_pack_id: string }) | null;
  subscription: (EligibilityResult & { subscription_id: string }) | null;
}

export const checkPurchaseEligibility = async (
  params: PurchaseEligibilityRequest
): Promise<PurchaseEligibilityResponse | undefined> => {
  try {
    return await post<PurchaseEligibilityResponse>(
      'public/orders/purchase-eligibility',
      params
    );
  } catch (error) {
    handleError(error);
  }
};
